/** Backend `SideType` enum — keep in sync with API. */
export const MOVEX_SIDE_TYPE = {
  UNILATERAL_ALTERNATING: 'UNILATERAL_ALTERNATING',
  UNILATERAL_CONTINUOUS: 'UNILATERAL_CONTINUOUS',
  BILATERAL: 'BILATERAL',
};

export const MOVEX_SIDE_TYPE_VALUES = Object.values(MOVEX_SIDE_TYPE);
